import { PATH_TO_CONTACT, PATH_TO_REGULATION } from 'src/config-global';

import type { NewFooterProps, FooterNavigationItem } from './types';

export const DEFAULT_LINKS: NewFooterProps['links'] = {
  contact: PATH_TO_CONTACT,
  regulation: '/Regulamento.pdf',
  privacy: PATH_TO_REGULATION,
  app: 'https://cidade-center-norte.web.app/SE9NRV9TQ1JFRU5TL2luaWNpbw==',
};

export const PLATFORM_LINKS: FooterNavigationItem[] = [
  { id: 'benefits', label: 'Benefícios' },
  { id: 'events', label: 'Eventos da Expo' },
  { id: 'howItWorks', label: 'Como funciona' },
  { id: 'account', label: 'Minha conta' },
];

export const SUPPORT_LINKS: FooterNavigationItem[] = [
  { id: 'contact', label: 'Fale com a gente' },
  { id: 'faq', label: 'Perguntas frequentes' },
  { id: 'regulation', label: 'Regulamento do programa' },
  { id: 'privacy', label: 'Política de privacidade' },
];

export const BRAND_LOGOS = [
  { file: 'shopping-center-norte.svg', name: 'Shopping Center Norte' },
  { file: 'lar-center.svg', name: 'Lar Center' },
  { file: 'expo-center-norte.svg', name: 'Expo Center Norte' },
  { file: 'center-norte-inc.svg', name: 'Center Norte Inc' },
  { file: 'instituto-center-norte.svg', name: 'Instituto Center Norte' },
];

export const ASSET_PATH = '/assets/new-footer';
